import { render } from "./ProductPackagesSelection.vue?vue&type=template&id=31cfb324&scoped=true"
import script from "./ProductPackagesSelection.vue?vue&type=script&lang=js"
export * from "./ProductPackagesSelection.vue?vue&type=script&lang=js"

import "./ProductPackagesSelection.vue?vue&type=style&index=0&id=31cfb324&lang=css"
import "./ProductPackagesSelection.vue?vue&type=style&index=1&id=31cfb324&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cfb324"]])

export default __exports__